import * as yup from 'yup'

export const updateSchemaBrinco = yup.object({
  idBrinco: yup.string().nullable().optional(),
  idFazenda: yup.string().required('A fazenda é obrigatória'),
  tipo: yup.string().nullable().optional(),
  data: yup.string().nullable().optional(),
  numeroCompleto: yup.string().required('O número completo é obrigatório'),
  numeroSufixo: yup.string().required('O número sufixo é obrigatório'),
  status: yup.string().required('O status é obrigatório'),
  acao: yup.string().nullable().optional(),
  idFicha: yup.string().nullable().optional(),
  prefixo: yup.string().nullable().optional(),
  sufixo: yup.string().nullable().optional(),
  ordem: yup.number().nullable().optional(),
  id: yup.string().nullable().optional()
})

export const updateBirthCertificateSchema = yup.object({
  idFicha: yup.string().nullable().optional(),

  nome: yup.string().nullable().optional(),

  data: yup.string().nullable().optional(),
  idFazenda: yup.string().required('A fazenda é obrigatória'),
  username: yup.string().required('O nome do usuário é obrigatório'),

  initialSufix: yup.string().when('idFicha', {
    is: (idFicha: string | null | undefined) => !!idFicha,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required('O número inicial é obrigatório')
  }),

  prefix: yup.string().when('idFicha', {
    is: (idFicha: string | null | undefined) => !!idFicha,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required('O prefixo é obrigatório')
  }),
  id: yup.string().nullable().optional(),

  brincos: yup.array(updateSchemaBrinco).notRequired().default([])
})

export type BirthCertificateForm = yup.InferType<typeof updateBirthCertificateSchema>
export type UpdateBrincoForm = yup.InferType<typeof updateSchemaBrinco>

export default updateBirthCertificateSchema
